import merge from 'deepmerge';

import type { NextI18nConfig } from './types';

let config: NextI18nConfig = {
  nonExplicitSupportedLngs: true,
  debug: false,
  i18n: { defaultLocale: 'fr', locales: ['fr', 'de'] },
  clientOnly: false,
};

export const setConfig = (customConfig: Partial<NextI18nConfig>) => {
  config = merge(config, customConfig, {
    customMerge: (key) => {
      if (key === 'locales') {
        return (_, incoming) => incoming;
      }
      return undefined;
    },
  });
};

export const getConfig = () => config;
